// 问答例子
export let quesExps = [{
    question: '夫妻分居两年可以判离吗？',
    answer: `<span style="font-weight: 600">核心结论：</span><br>
        夫妻起诉离婚，法院通常会以夫妻感情是否破裂为依据作出判决，那么，夫妻分居两年，法院是否会判离呢？通常情况下是可以的，但是需要符合法定条件。<br>
        对此，我将结合大量的法庭实战经验，给出以下分析和总结！<br><br>

        <span style="font-weight: 600">法律依据：</span><br>
        根据《民法典》第1079条规定，人民法院审理离婚案件，应当进行调解；如果感情确已破裂，调解无效的，应当准予离婚。有下列情形之一，调解无效的，应当准予离婚：<br>
        （一）重婚或者与他人同居；<br>
        （二）实施家庭暴力或者虐待、遗弃家庭成员；<br>
        （三）有赌博、吸毒等恶习屡教不改；<br>
        （四）因感情不和分居满二年；<br>
        （五）其他导致夫妻感情破裂的情形。<br><br>

        <span style="font-weight: 600">法律分析：</span><br>
        根据上述规定，因感情不和分居满二年，调解无效的，法院应准予离婚。<br>
        据此可知，因感情不合分居两年是作为法院判离的一个依据。在我以往经手的案件中，就有不少以分居为由起诉离婚的夫妻，最后都成功的拿到了离婚判决。<br><br>

        <span style="font-weight: 600">律师观点：</span><br>
        不过，作为专业的离婚律师，需要提醒你以下几点：<br>
        第一、并不是所有分居两年的情形都能判离，分居两年判离的前提必须是以感情不合为由，如果夫妻俩是因为工作原因或者非因感情不合的原因而分居，那么法院可能不会通过你们的离婚申请；<br>
        第二、分居两年的时间必须是连续的，很多夫妻分居一年后又同居，后来又分居一年提出离婚，被法院驳回了，就是因为分居的时间不是持续的；<br>
        第三、分居两年必须要保留证据，如：一方的租房合同、双方签订的分居协议、能够证明双方确实分居两年的聊天记录以及其他凭证。如果没有证据，法院很有可能会驳回你的离婚申请。<br><br>

        <span style="font-weight: 600">律师建议：</span><br>
        婚姻非儿戏，无论是结婚还是离婚，男女双方都要充分考虑清楚再做决定。在实践中，起诉离婚被判离的情形并不是很多，其中的主要原因就是缺乏夫妻感情破裂的证据，<br>
        所以，想要离婚，不仅要符合法定的准予判离的条件，还要有充足的证据。大家如果还有婚姻法律问题，欢迎留言哦～`
}, {
    question: '结婚半月就离婚，男方给的20万彩礼该不该还？',
    answer: `<span style="font-weight: 600">核心结论：</span><br>
        大概率需要返还<br><br>

        <span style="font-weight: 600">法律依据：</span><br>
        《最高人民法院关于审理涉彩礼纠纷案件适用法律若干问题的规定》第五条<br><br>

        <span style="font-weight: 600">法律分析：</span><br>
        双方已办理结婚登记且共同生活，离婚时一方请求返还按照习俗给付的彩礼的，人民法院一般不予支持。
        但是，如果共同生活时间较短且彩礼数额过高的，人民法院可以根据彩礼实际使用及嫁妆情况，综合考虑彩礼数额、共同生活及孕育情况、双方过错等事实，
        结合当地习俗，确定是否返还以及返还的具体比例。<br>
        人民法院认定彩礼数额是否过高，应当综合考虑彩礼给付方所在地居民人均可支配收入、给付方家庭经济情况以及当地习俗等因素。<br>
        依据上述司法解释，针对“退还彩礼”问题，需要根据具体情况判断。主要判断要点在于“共同生活时间较短”以及“彩礼数额过高”<br><br>

        <span style="font-weight: 600">律师观点：</span><br>
        回到我们的问题中，对应上述判断要点的核心信息是：第一，“结婚半月就离婚”；第二，“男方给了20万彩礼”。<br>
        那么20万的彩礼金额是否属于“过高”？<br>
        有法院在判决中曾解释：“彩礼的数额将近本地农村人均可支配收入的10倍，远超一般人的承受能力，应当认定彩礼数额过高。”同时根据国家统计局发布的数据，2024年上半年，农村居民人均可支配收入为11272元。<br>
        结合上面两个条件，可以得出一般性结论，20万彩礼通常可以认为是比较高的，且双方结婚到离婚仅半个月，符合“共同生活时间较短“的要求，因此，该20万彩礼大概率是要返还的。<br>
        此外，还可以参考类似案件，例如，湖北仙桃市人民法院审理的一起案件中，双方婚后生活不足半月便开始分居，最终女方返还了部分彩礼。<br><br>

        <span style="font-weight: 600">律师建议：</span><br>
        彩礼，作为中华民族婚姻习俗中的重要组成部分，承载着对新人家庭和谐美满的深切期盼。然而，当彩礼的数额被脱离家庭经济实际状况，
        错误地作为衡量爱情深浅的唯一标尺时，反而可能诱发一系列矛盾与冲突，成为破坏家庭和谐的不稳定因素。
        因此，我们应以理性态度审视彩问题，同时，当出现彩礼纠纷时，也不能碍于情面，放弃自己的合法权益。`
}, {
    question: '养父常年对养女施暴、侵犯，养女策划将其杀害，会判死刑吗？',
    answer: `<span style="font-weight: 600">核心结论：</span><br>
        大概率不会判死刑<br><br>

        <span style="font-weight: 600">法律依据：</span><br>
        《中华人民共和国刑法》第二百三十二条<br>
        《中华人民共和国刑法》第十四条<br><br>

        <span style="font-weight: 600">法律分析：</span><br>
        第232条规定了故意杀人罪的量刑：“故意杀人的，处死刑、无期徒刑或者十年以上有期徒刑；情节较轻的，处三年以上十年以下有期徒刑。”<br>
        第14条解释了“故意”的内涵，即：“明知自己的行为会发生危害社会的结果，并且希望或者放任这种结果发生，因而构成犯罪的，是故意犯罪。”<br><br>

        <span style="font-weight: 600">律师观点：</span><br>
        养女策划杀人，足以证明其对行为对象和行为性质有明确的认识，主观上就是希望养父死亡的，客观上实施了杀人行为，构成故意杀人罪是没有疑问的。<br>
        但我们也要关注刑法中的“被害人过错”制度，详细来说，就是被害人出于主观上的过错，实施了错误或者不当的行为，
        且该行为违背了法律和伦理道德，侵犯了被告人的合法权益，客观上激发了犯罪行为的发生，具体到本问题中，养父的施暴、侵犯本身就是犯罪行为，
        侵犯了养女合法的人身权益，激发了养女的故意杀人行为，构成了“被害人过错”，那么，养女的杀人行为可能被认为符合情节较轻的情形，是有可能被判处三年以上十年以下有期徒刑的<br>
        同时，我们再来关注一下《关于审理故意杀人、故意伤害案件正确适用死刑问题的指导意见》的相关规定，对于因婚烟家庭矛盾激化引发的故意杀人案件，
        在适用死刑时要特别慎重。如：被害人一方有明显过错或者对矛盾激化负有直接责任的除犯罪情节特别恶劣、犯罪后果特别严重、人身危险性极大的被告人外，一般可考虑不判处死刑立即执行。
        基于上述分析，律师认为，养女被判处死刑的概率很低。<br><br>

        <span style="font-weight: 600">律师建议：</span><br>
        刑法规定对已死之人不再追究刑事责任，主要是基于对其施加刑罚已毫无意义，但养父的家暴和侵犯等加害行为最终将体现在对养女的审判量刑中，
        也即，会成为养女构成“情节较轻”的有力证据，然而，故意杀人是非常严重的违法行为，不管出于何种理由，养女的杀人行为终将被法律惩治。
        律师在此特别提醒，如果你或你认识的人正在遭受家庭暴力，可以尝试以下方法来逃脱：<br>
        1. 报警：立即报警。警方可以提供保护，并采取适当的行动来制止家庭暴力。<br>
        2. 寻求帮助：向信任的朋友、家人、邻居或社区组织寻求帮助。他们可以提供庇护所、食物和衣服等基本需求，并帮助你制定逃脱计划。<br>
        3. 咨询律师：寻求法律援助是非常重要的。律师可以帮助你了解你的权利，并为你提供法律建议和支持。<br>
        4. 保护自己的证据：收集和保存所有证据，如照片、录音、医疗报告等，这些证据在离婚诉讼中将会起到很重要的作用。<br>
        5. 避免单独面对施暴者：尽量避免与施暴者单独相处，尤其是在他们情绪不稳定或醉酒的情况下。<br>
        6. 寻求心理咨询：遭受家庭暴力可能会对心理健康造成严重影响，寻求心理咨询师的帮助，处理相关情绪问题和压力。"`
}];